<template>
  <Row class="widget-container">
    <i-col :xs="24" :sm="24" :md="12" :lg="12">
      <Card class="widget-height-md ivu-card-custom m-1" shadow>
        <div slot="title" class="with-icon">
          <h4>
            <table style="width: 100%;" border="0">
              <tr>
                <td align="left">
                  <h6 class="tableHeader" style="width: 100%">
                    <span v-show="showAllEvents">
                      <Icon type="ios-eye" @click.native='showEvents' size="30" color="white"
                            title="Show Active Events only"/>
                     All Events
                    </span>
                    <span v-show="!showAllEvents">
                      <Icon type="ios-eye-off" @click.native='showEvents' size="30" title="Show All Events"/>
                      Active Events
                    </span>
                  </h6>
                </td>
                <td align="left">
                  <DatePicker style="font-size: 10pt"
                              transfer
                              :open="open"
                              :value="selectedYear"
                              type="year"
                              confirm
                              @on-change="changeEventYear"
                              @on-ok="open = !open">
                    <a href="javascript:void(0)" @click="open = !open" @blur="open = false">
                      <Icon type="ios-calendar-outline"></Icon>
                      <template style="font-size: 5pt" v-if="selectedYear === ''">Select year</template>
                      <template v-else>{{ selectedYear }}</template>
                    </a>
                  </DatePicker>
                </td>
                <td>
                  <Divider type="vertical"/>
                </td>
                <td align="left">
                  <table style="width: 100%">
                    <tr>
                      <td style="width: 40%;">
                        <Select @on-change="filterSearch" title="Search by" clearable v-model="searchBy" size="small"
                                placeholder="Search by">
                          <Option v-for="item in searchFilters" :value="item" :key="item">{{ item }}</Option>
                        </Select>
                      </td>
                      <td style="width: 60%;">
                        <AutoComplete v-show="searchBy === 'Event Name'" clearable placeholder="Input Event Name"
                                      size="small" :data="eventNames" :filter-method="filterMethod" v-model="eventName"
                                      icon="ios-search" @on-change="getEventsData" transfer>
                        </AutoComplete>
                        <AutoComplete v-show="searchBy === 'Event Place'" clearable placeholder="Input Event Place"
                                      size="small" :data="eventLocations" :filter-method="filterMethod"
                                      v-model="eventPlace" icon="ios-search" @on-change="getEventsData" transfer>
                        </AutoComplete>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </h4>
          <Icon type="ios-add-circle-outline" color="white" size="24"
                @click.native="$refs.eventForm.openEventForm('Create New Event','add')"
                title="Add New Event"/>
        </div>
        <div class="widget-data full-height">
          <Table ref="eventDataTable" :columns="eventDataColumns" :data="eventItems"
                 class="full-height show-borders initial-height" stripe border shadow @on-sort-change="onSortChangeEvents"></Table>
          <Spin size="large" fix v-if="spinShowEvent"></Spin>
          <Page v-show="showEventPager" :total="dataEventCount" :page-size="pageEventSize"
                show-total show-sizer :page-size-opts="pageEventSizer" transfer
                @on-change="changeSelectedEventPage" @on-page-size-change="changeEventPageSize">
          </Page>
        </div>
        <eventForm ref="eventForm" @addForm="add_Event" @viewForm="view_Event"
                   @updateForm="update_Event"></eventForm>
        <eventParticipantForm ref="eventParticipantForm"></eventParticipantForm>

        <Modal v-model="eventConfirmDelete" title="CONFIRMATION" @on-ok="remove_Event(eventSelected.index)"
               ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
          <div class="confirmation-body">
            <p>
              <Icon type="md-help-circle" size="24" color="#f90"/>
              <span>{{eventDeleteMessage}}</span>
            </p>
          </div>
          <div slot="footer">
            <Button size="large" @click="eventConfirmDelete=false">Cancel</Button>
            <Button size="large" @click="remove_Event(eventSelected.index);eventConfirmDelete=false"
                    class="submit" type="error">Delete
            </Button>
          </div>
        </Modal>

        <Modal v-if="this.eventSelected" v-model="eventConfirmTurnIntoProductionMode" title="CONFIRMATION" @on-ok="remove_Event(eventSelected.index)"
               ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
          <div class="confirmation-body">
            <header>
              <h6>Which mode do you want to use when moving the event to production state ?</h6>
            </header>

            <body class="my-3">
              <div v-if="this.eventSelected.row.leadsCount > 0">{{ this.eventSelected.row.leadsCount }} existing leads on {{ this.eventSelected.row.companiesHavingLeadsCount }} companies for {{ this.eventSelected.row.eventName }}</div>
              <div v-else>No existing lead for {{ this.eventSelected.row.eventName }}</div>

              <RadioGroup v-model="turnIntoProductionSelectedMode" vertical>
                  <Radio label="withoutDataDeletion" class="text-green">
                      <Icon type="md-bookmark" size="30"></Icon>
                      <span style="font-size: 1.3em;">WITHOUT data deletion</span>
                  </Radio>
                  <Radio label="withDataDeletion" class="text-red">
                      <Icon type="md-trash" size="30"></Icon>
                      <span style="font-size: 1.3em;">WITH data deletion</span>
                  </Radio>
              </RadioGroup>
            </body>
          </div>
          <div slot="footer">
            <Button size="large" @click="eventConfirmTurnIntoProductionMode = false">Cancel</Button>
            <Button size="large" class="submit" type="success" @click="turnIntoProductionMode()">Confirm</Button>
          </div>
        </Modal>
      </Card>
    </i-col>

    <i-col :xs="24" :sm="24" :md="12" :lg="12">
      <Card class="widget-height-md ivu-card-custom m-1" shadow>
        <div slot="title" class="with-icon">
          <h4>
            <table style="width: 100%;" border="0">
              <tr>
                <td style="width: 50%" align="left">
                  <h6 class="tableHeader" style="width: 100%">
                    <span v-show="showAllCompanies">
                    <Icon type="ios-eye" @click.native='showCompanies' size="30" color="white"
                          title="Show Active Companies only"/>
                    All Companies
                    </span>
                    <span v-show="!showAllCompanies">
                    <Icon type="ios-eye-off" @click.native='showCompanies' size="30"
                          title="Show All Companies"/>
                    Active Companies
                    </span>
                  </h6>
                </td>
                <td style="width: 45%" align="left">
                  <AutoComplete clearable placeholder="Filter company by event access"
                                size="small"
                                :data="eventNames" :filter-method="filterMethod" v-model="searchByEvent"
                                icon="ios-search" style="width:227px;" @on-change="getCompaniesData" transfer>
                  </AutoComplete>
                </td>
              </tr>
            </table>
          </h4>
          <Icon type="ios-add-circle-outline" color="white" size="24"
                @click.native="$refs.companiesForm.openCompanyForm('Create New Company','add')"
                title="Add New Company"/>
        </div>
        <div class="widget-data full-height">
          <Table ref="companyDataTable" :columns="companyDataColumns" :data="companyItems" class="full-height show-borders initial-height" stripe border shadow @on-sort-change="onSortChangeCompanies"></Table>
          <Spin size="large" fix v-if="spinShowCompany"></Spin>
          <Page v-show="showCompanyPager" :total="dataCompanyCount" :page-size="pageCompanySize"
                show-total show-sizer :page-size-opts="pageCompanySizer" transfer
                @on-change="changeSelectedCompanyPage" @on-page-size-change="changeCompanyPageSize">
          </Page>
        </div>
        <companiesForm ref="companiesForm" @addForm="add_Company" @viewForm="view_Company"
                       @updateForm="update_Company">
        </companiesForm>
        <companyLicenseForm ref="companyLicenseForm"></companyLicenseForm>
        <Modal v-model="companyConfirmDelete" title="CONFIRMATION" @on-ok="remove_Company(companyDeleteIndex)"
               ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
          <div class="confirmation-body">
            <p>
              <Icon type="md-help-circle" size="24" color="#f90"/>
              <span>{{companyDeleteMessage}}</span>
            </p>
            <p class="submessage" v-show="companyIdToBeDeleted">
              <Icon type="ios-checkmark" class="greenBox" @click="changeCompanyBox"/>
              Hard Delete<br/>*all associated data will be erased.
            vscode-file://vscode-app/c:/Users/ttsang/AppData/Local/Programs/Microsoft%20VS%20Code/resources/app/out/vs/code/electron-sandbox/workbench/workbench.html</p>
            <p class="submessage" v-show="!companyIdToBeDeleted">
              <Icon type='md-close' class="grayBox" @click="changeCompanyBox"/>
              Soft Delete<br/>*all associated data will be hidden.
            </p>
          </div>
          <div slot="footer">
            <Button size="large" @click="companyConfirmDelete=false">Cancel</Button>
            <Button size="large" class="submit" type="error"
                    @click="remove_Company(companyDeleteIndex);companyConfirmDelete=false">Delete
            </Button>
          </div>
        </Modal>
      </Card>
    </i-col>
  </Row>
</template>
<script>
  import {deleteCompany, getCompanies} from '../../services/Companies.service'
  import { deleteEvent, getEvents, putEventToProductionMode } from '../../services/Events.service'
  import companiesForm from './companyForm'
  import eventForm from './eventForm'
  import eventParticipantForm from './eventParticipantForm'
  import companyLicenseForm from './companyLicenseForm'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'
  import moment from 'moment-timezone'

  export default {
    components: {
      companiesForm, eventForm, eventParticipantForm, companyLicenseForm
    },
    props: ['forms'],
    data() {
      return {
        open: false,
        yearList: [],
        selectedYear: '',

        spinShowCompany: true,
        spinShowEvent: true,
        companyConfirmDelete: false,
        companyDeleteMessage: '',
        companyDeleteIndex: null,
        companyItems: [],
        companyDataColumns: [
          {
            title: 'Company Name',
            key: 'companyName',
            align: 'left',
            className: 'paddingIndent',
            sortable: true,
            sortMethod: function(a, b, type){
              return; // Prevent default sort
            } 
          },
          {
            title: 'Users',
            key: 'users',
            align: 'left',
            minWidth: 80,
            maxWidth: 80,
            className: 'paddingIndent',
            sortable: false,
            render: (h, params) => {
              return h('Icon', {
                props: {
                  type: 'ios-people-outline',
                  size: '24'
                },
                attrs: {
                  title: 'Edit Users'
                },
                on: {
                  click: () => {
                    localStorage.setItem('selected_company_users', params.row.companyId);
                    bus.$emit('getActiveLink', 'Users');
                  }
                }
              });
            }
          },
          {
            title: '# Licenses',
            key: 'numLicenseIds',
            align: 'left',
            minWidth: 90,
            maxWidth: 90,
            className: 'paddingIndent',
            sortable: false
          },
          {
            title: 'Action',
            key: 'action',
            align: 'Center',
            minWidth: 140,
            maxWidth: 140,
            className: 'paddingIndent',
            render: (h, params) => {
              let editIcon = h('Icon', {
                props: {
                  type: 'ios-create-outline',
                  size: '24'
                },
                attrs: {
                  title: 'Edit Company'
                },
                on: {
                  click: () => {
                    this.$refs.companiesForm.openCompanyForm('Edit Company', 'edit');
                    this.$refs.companiesForm.setFormValue(params.row, params.index);
                  }
                }
              });
              let deleteIcon = h('Icon', {
                props: {
                  type: 'ios-close-circle-outline',
                  color: '#9b3035',
                  size: '24'
                },
                attrs: {
                  title: 'Delete Company'
                },
                on: {
                  click: () => {
                    this.companyDeleteMessage = `Are you sure you want to delete "${params.row.companyName}" ?`;
                    this.companyConfirmDelete = true;
                    this.companyDeleteIndex = params.index;
                  }
                }
              });
              let keyIcon = h('Icon', {
                props: {
                  type: 'ios-key-outline',
                  size: '24'
                },
                attrs: {
                  title: 'Update Licenses'
                },
                on: {
                  click: () => {
                    this.updateLicenses(params.row);
                  }
                }
              });

              let icons = [editIcon, deleteIcon, keyIcon];
              return h('div', [icons]);
            }
          }
        ],
        companyDataList: [{
          companyId: null,
          languageId: null,
          companyName: null,
          phone: null,
          email: null,
          address: null,
          city: null,
          country: null,
          logoUrl: null,
          logoImage: null,
          barcode: null,
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
          updatedBy: null,
          updatedDate: null,
          userIds: null,
          formIds: null,
          leadIds: null,
          licenseIds: null,
          eventIds: null,
          isNewLogo: false
        }],
        companyIdToBeDeleted: false,
        showAllCompanies: false,
        dataCompanyCount: 0,
        pageCompanySizer: [10, 25, 50, 100],
        pageCompanySize: 10,
        historyCompanyData: [],
        showCompanyPager: false,

        eventConfirmTurnIntoProductionMode: false,
        turnIntoProductionSelectedMode: "withoutDataDeletion",

        eventConfirmDelete: false,
        eventDeleteMessage: '',
        eventSelected: null,
        eventItems: [],
        eventDataColumns: [
          {
            title: 'Event Name',
            key: 'eventName',
            minWidth: 100,
            maxWidth: 100,
            align: 'left',
            className: 'paddingIndent',
            sortable: true,
            sortMethod: function(a, b, type){
              return; // Prevent default sort
            },
            render: (h, params) => {
              let warningIcon = h('Icon', {
                props: {
                  type: 'md-warning',
                  size: '22'
                },
                style: {
                    marginRight: '3px',
                    color: 'var(--warning)'
                },
                attrs: {
                  title: 'Turn event into production mode'
                },
                on: {
                  click: () => {
                    this.eventSelected = params;
                    this.eventConfirmTurnIntoProductionMode = true;
                  }
                }
              });

              if(params.row.eventStatus === 0){
                return h('div', [
                  warningIcon, h("strong", params.row.eventName)
                ]);
              }
              else {
                return h("strong", params.row.eventName);
              }
            }
          },
          {
            title: '# Licenses',
            key: 'numEventLicenseIds',
            align: 'left',
            minWidth: 80,
            maxWidth: 80,
            className: 'paddingIndent',
            sortable: false
          },
          {
            title: '# Participants',
            key: 'numParticipantIds',
            minWidth: 80,
            maxWidth: 80,
            align: 'left',
            className: 'paddingIndent',
            sortable: false
          },
          {
            title: '# Forms',
            key: 'numFormIds',
            minWidth: 80,
            maxWidth: 80,
            align: 'left',
            className: 'paddingIndent',
            sortable: false
          },
          {
            title: 'Action',
            key: 'action',
            align: 'center',
            minWidth: 100,
            maxWidth: 100,
            className: 'paddingIndent',
            render: (h, params) => {
              let editIcon = h('Icon', {
                props: {
                  type: 'ios-create-outline',
                  size: '24'
                },
                attrs: {
                  title: 'Edit Event'
                },
                on: {
                  click: () => {
                    getCompanies(false).then(a => {
                      let companyList = [];
                      let selectedCompany = [];

                      if (params.row.companyIds) {
                        params.row.companyIds.forEach(function (id) {
                          let company = a.data.filter(a => a.companyId == id)[0];
                          if (company) {
                            selectedCompany.push(company.companyId);
                          }
                        });
                      }
                      a.data.map(item => {
                        companyList.push(item);
                      });
                      this.$refs.eventForm.openEventForm('Edit Event', 'edit');
                      this.$refs.eventForm.setFormValue(params.row, params.index, selectedCompany, companyList);
                    });
                  }
                }
              });
              let deleteIcon = h('Icon', {
                props: {
                  type: 'ios-close-circle-outline',
                  color: '#9b3035',
                  size: '24'
                },
                attrs: {
                  title: 'Delete Event'
                },
                on: {
                  click: () => {
                    this.eventDeleteMessage = `Are you sure you want to delete "${params.row.eventName}" ?`;
                    this.eventConfirmDelete = true;
                    this.eventSelected = params;
                  }
                }
              });
              let linkIcon = h('Icon', {
                props: {
                  type: 'ios-link',
                  size: '24'
                },
                attrs: {
                  title: 'Upload Participants'
                },
                on: {
                  click: () => {
                    this.$refs.eventParticipantForm.openEventParticipantForm('Edit Event Participants', 'edit');
                    this.$refs.eventParticipantForm.setFormValue(params.row, params.index);
                  }
                }
              });
              let syncIcon = h('Icon', {
                props: {
                  type: 'ios-cog-outline', // cog icon that opens the contact form settings of an event
                  size: '24'
                },
                attrs: {
                  title: 'Sync Lead Form'
                },
                on: {
                  click: () => {
                    const self = this;
                    let event = self.eventItems[params.index];
                    bus.$emit('getActiveLink', 'MyLeadForms');
                    self.setFormOpened(true);
                    localStorage.setItem('formOpened', true);
                    setTimeout(function () {
                      bus.$emit('syncLeadForm', event);
                    }, 100);
                  }
                }
              });
              let icons = [editIcon, deleteIcon, linkIcon, syncIcon];

              if(params.row.deleted){
                return h('span', "The event is already archived");
              }
              else {
                return h('span', [icons]);
              }
            }
          }
        ],
        eventDataList: [{
          eventId: null,
          eventName: null,
          location: null,
          startDate: null,
          endDate: null,
          bannerUrl: null,
          bannerImage: null,
          iconUrl: null,
          iconImage: null,
          participantForm: null,
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
          updatedBy: null,
          updatedDate: null,
          userIds: null,
          leadIds: null,
          formIds: null,
          licenseIds: null,
          participantIds: null,
          companyIds: null,
          numEventLicenseIds: null,
          numParticipantIds: null,
          numFormIds: null,
          isNewIcon: false,
          isNewBanner: false,
        }],
        showAllEvents: false,
        dataEventCount: 0,
        pageEventSizer: [10, 25, 50, 100],
        pageEventSize: 10,
        historyEventData: [],
        showEventPager: false,
        searchBy: '',
        searchFilters: ['Event Name', 'Event Place'],
        eventName: '',
        eventPlace: '',
        eventNames: [],
        eventLocations: [],
        searchByEvent: ''
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser', 'getFormOpened']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
    },
    watch: {
      companies(companies) {
        this.setCompanyTableData(companies);
      },
      events(events) {
        this.setEventTableData(events);
      }
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser', 'setFormOpened']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),
      turnIntoProductionMode(){
        putEventToProductionMode(this.eventSelected.row.eventId, this.turnIntoProductionSelectedMode === "withDataDeletion").then(response => {
          this.$Message.success({
              content: "Event successfully turned into production mode",
              duration: 3
          });
          this.eventConfirmTurnIntoProductionMode = false;
          this.getEventsData(); // Reload events' data
        }).catch(error => {
          this.$Message.error({
              content: "An error occurred while turning the event into production mode: " + error,
              duration: 3
          });
        });
      },
      onSortChangeEvents({ column, key, order }){ // order : asc, desc, normal
        if(order === "asc") {
          this.historyEventData.sort((a, b) => a.eventName.toUpperCase().localeCompare(b.eventName.toUpperCase()));
        }
        else if(order === "desc") {
          this.historyEventData.sort((a, b) => -1 * a.eventName.toUpperCase().localeCompare(b.eventName.toUpperCase()));
        }
        else {
          this.historyEventData.sort((a, b) => (a.numParticipantIds < b.numParticipantIds) ? 1 : -1);
        }
        this.eventItems = this.historyEventData.slice(0, this.pageEventSize);
      },
      onSortChangeCompanies({ column, key, order }){
        if(order === "asc"){
          this.historyCompanyData.sort((a, b) => a.companyName.toUpperCase().localeCompare(b.companyName.toUpperCase()));
        }
        else if(order === "desc"){
          this.historyCompanyData.sort((a, b) => -1 * a.companyName.toUpperCase().localeCompare(b.companyName.toUpperCase()));
        }
        else {
          this.historyCompanyData.sort((a, b) => (a.numLicenseIds < b.numLicenseIds) ? 1 : -1);
        }
        this.companyItems = this.historyCompanyData.slice(0, this.pageCompanySize);
      },
      filterSearch(val) {
        if (val === 'Event Name') {
          this.eventPlace = '';
        }
        if (val === 'Event Place') {
          this.eventName = '';
        }
        if (val == null) {
          this.eventName = '';
          this.eventPlace = '';
          this.getEventsData();
        }
      },

      editForm(params) {
        this.items = [];
        this.formDataList = [];
        this.form.title = params.row.title;
        this.form.formId = params.row.formId;
        this.form.companyId = params.row.companyId;
        this.form.eventId = params.row.eventId;
        this.form.desc = params.row.desc;
        this.form.order = params.row.order;
        this.form.isLeadForm = params.row.isLeadForm;
        this.form.isSurveyForm = params.row.isSurveyForm;
        this.form.isActive = params.row.isActive;

        if (params.row.questions) {
          //loop thru
          params.row.questions.map((q, ix) => {
            if (q.title.toLowerCase() == 'id') {
              q.order = 1;
            }
            if (q.title.toLowerCase() == 'first name' || q.title.toLowerCase() == 'firstname') {
              q.order = 2;
            }
            if (q.title.toLowerCase() == 'last name' || q.title.toLowerCase() == 'lastname') {
              q.order = 3;
            }
            if (q.title.toLowerCase() == 'country') {
              q.order = 4;
            }
            if (q.title.toLowerCase() == 'email') {
              q.order = 5;
            }

            if (q.fieldCode == 'leadRating' || q.fieldCode.toLowerCase() == 'rating') {
              this.showRating = true;
            }
            if (q.fieldCode == 'address') {
              this.showAddress = true;
            }
            if (q.fieldCode == 'city') {
              this.showCity = true;
            }
            if (q.fieldCode == 'phoneNumber') {
              this.showPhone = true;
            }
            if (q.fieldCode == 'jobTitle') {
              this.showJobTitle = true;
            }

            this.formDataList.push({
              allowOther: q.allowOther,
              choices: q.choices,
              fieldCode: q.fieldCode,
              formId: params.row.formId,
              inputType: q.inputType,
              questionId: q.questionId,
              order: q.order,
              label: q.title,
              type: q.type,
              hide: !q.visible,
              optional: q.optional
            });
          });
        }
        //order questions
        this.formDataList.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
        this.formOpened = true;
        this.form.questions = this.formDataList;
        return this.formDataList;
      },
      saveForm() {
        let list = [];
        this.formDataList.map((q) => {
          let fieldCode = q.fieldCode;
          if (q.fieldCode == 'other') {
            fieldCode = q.label.replace(/\s+/g, '-').toLowerCase();
          }
          list.push({
            questionId: q.questionId,
            formId: q.formId,
            title: q.label,
            type: q.type,
            inputType: q.inputType,
            fieldCode: fieldCode,
            visible: !q.hide,
            optional: q.optional,
            allowOther: q.allowOther,
            order: q.order,
            choices: q.choices
          });
        });
        this.form.questions = [];
        this.form.questions = list;

        const data = Object.assign({}, this.form);
        delete data['_index'];
        delete data['_rowKey'];
        updateForm(this.form.formId, data).then(response => {
          this.$emit('updateForm', this.form.formId, data);
          this.$Message.success('Form successfully update!');
          this.getFormsData();
        }).catch(error => {
          this.$Message.error('Failed updating form ' + error);
        });
      },
      goBack() {
        this.getFormsData();
      },
      handleReset() {
        let self = this;
        Object.keys(this.formDataList).forEach(function (key, i) {
          self.formDataList[key] = '';
        });
      },
      reRouteUser() {
        let role = localStorage.getItem('role');
        if (role != 'admin') {
          if (this.$route.name == 'GlobalAdministration' || this.$route.currentRoute.name == 'GlobalAdministration')
            bus.$emit('getActiveLink', 'GeneralDashboard');
        }
      },

      setCompanyTableData(companies) {
        this.companyItems = companies;
        this.spinShowCompany = false;
      },
      showCompanies() {
        if (this.showAllCompanies) {
          this.showAllCompanies = false;
        } 
        else {
          this.showAllCompanies = true;
        }
        this.getCompaniesData();
      },
      getCompaniesData() {
        const self = this;
        self.spinShowCompany = true;
        self.showCompanyPager = false;
        getCompanies(this.showAllCompanies).then(response => {
          let result = [];
          response.data.map((company) => {
            result.push({
              companyId: company.companyId,
              companyName: company.companyName,
              address: company.address,
              barcode: company.barcode,
              city: company.city,
              country: company.country,
              email: company.email,
              languageId: company.languageId,
              logoUrl: company.logoUrl,
              logoImage: company.logoImage,
              isNewLogo: false,
              phone: company.phone,
              eventIds: company.eventIds,
              deleted: company.deleted,
              deletionDate: company.deletionDate,
              createdBy: company.createdBy,
              createdDate: company.createdDate,
              updatedBy: company.updatedBy,
              updatedDate: company.updatedDate,
              numLicenseIds: company.licensesCount,
            });
          });

          self.companyItems = result;
          self.historyCompanyData = result;

          if (self.searchByEvent) {
            let evtId = self.eventItems.filter(a => a.eventName.toLowerCase() === self.searchByEvent.toLowerCase()).map(b => b.eventId);
            var temp = [];
            var src = self.companyItems;
            src.map(function (a) {
              a.eventIds.map(function (b) {
                if (b == evtId) temp.push(a);
              })
            });
            self.historyCompanyData = temp;
          }

          self.dataCompanyCount = self.companyItems.length;
          if (self.historyCompanyData.length < self.pageCompanySize) {
            self.companyItems = self.historyCompanyData;
          } 
          else {
            self.companyItems = self.historyCompanyData.slice(0, self.pageCompanySize);
          }
          if (self.companyItems.length > 0) {
            self.showCompanyPager = true
          }
          self.spinShowCompany = false;
        });
      },
      showSpinCompany() {
        this.spinShowCompany = true;
      },
      add_Company(data) {
        this.companyItems.push(data)
      },
      update_Company(id, data) {
        let itemIndex = this.companyItems.map(i => {
          return i.companyId;
        }).indexOf(id)
        this.companyItems.splice(itemIndex, 1, data);
      },
      view_Company(id, data) {
        let itemIndex = this.companyItems.map(i => {
          return i.companyId;
        }).indexOf(id)
        this.companyItems.splice(itemIndex, 1, data);
      },
      remove_Company(index) {
        let companyId = this.companyItems[index].companyId;
        deleteCompany(companyId, this.companyIdToBeDeleted).then(response => {
          this.companyItems.splice(index, 1);
          this.getAllEvents_Companies();
          this.$Message.success('Company successfully deleted!');
        }).catch(error => {
          this.$Message.error('Failed deleting Company');
        })
      },
      changeCompanyBox() {
        if (this.companyIdToBeDeleted) {
          this.companyIdToBeDeleted = false;
        } else {
          this.companyIdToBeDeleted = true;
        }
      },
      updateLicenses(company) {
        this.$refs.companyLicenseForm.openLicenseForm('Edit Licenses', 'edit');
        this.$refs.companyLicenseForm.setFormValue(company.companyId);
      },
      changeCompanyPageSize(size) {
        this.pageCompanySize = size;
        this.changeSelectedCompanyPage(1);
      },
      changeSelectedCompanyPage(index) {
        let _start = (index - 1) * this.pageCompanySize;
        let _end = index * this.pageCompanySize;
        this.companyItems = this.historyCompanyData.slice(_start, _end);
      },

      setEventTableData(events) {
        this.eventItems = events;
        this.spinShowEvent = false;
      },
      showEvents() {
        if (this.showAllEvents) {
          this.showAllEvents = false;
        } else {
          this.showAllEvents = true;
        }
        this.getEventsData();
      },
      getEventsData() {
        const self = this;
        this.spinShowEvent = true;
        this.yearList = [];
        let eventNameList = [];
        let eventPlaceList = [];
        let currYear = parseInt(moment().format('YYYY'));
        let prevYear = (currYear - 1).toString();
        let prevPrevYear = (currYear - 2).toString();
        this.yearList.push(currYear.toString(), prevYear, prevPrevYear);

        this.showEventPager = false;
        getEvents(this.showAllEvents).then(response => {
          let result = [];
          response.data.map((event) => {
            result.push({
              eventId: event.eventId,
              eventName: event.eventName,
              location: event.location,
              startDate: event.startDate,
              endDate: event.endDate,
              bannerUrl: event.bannerUrl,
              bannerImage: event.bannerImage,
              iconUrl: event.iconUrl,
              iconImage: event.iconImage,
              participantForm: event.participantForm,
              scanMode: event.scanMode === null ? '' : event.scanMode,
              createdBy: event.createdBy,
              createdDate: event.createdDate,
              deleted: event.deleted,
              deletionDate: event.deletionDate,
              updatedBy: event.updatedBy,
              updatedDate: event.updatedDate,
              companyIds: event.companyIds,
              leadsCount: event.leadsCount,
              companiesHavingLeadsCount: event.companiesHavingLeadsCount,
              numEventLicenseIds: event.licensesCount,
              numParticipantIds: event.participantsCount,
              numFormIds: event.formsCount,
              isNewIcon: false,
              isNewBanner: false,
              eventStatus: event.eventStatus
            });
          });
          self.eventItems = result;
          self.eventItems.sort(function (a, b) {
            return a.startDate > b.startDate ? -1 : a.startDate < b.startDate ? 1 : 0;
          });
          eventNameList = result.map(a => a.eventName);
          self.eventNames = eventNameList.filter(function (item, index) {
            return eventNameList.indexOf(item) >= index;
          });
          eventPlaceList = result.map(a => a.location);
          self.eventLocations = eventPlaceList.filter(function (item, index) {
            return eventPlaceList.indexOf(item) >= index;
          });
          self.historyEventData = self.eventItems;

          if (self.selectedYear) {
            self.historyEventData = self.historyEventData.filter(a => a.endDate.indexOf(self.selectedYear) > -1);
          } else {
            self.selectedYear = '';
          }

          if (self.eventName) {
            self.historyEventData = self.historyEventData.filter(a => a.eventName.toLowerCase() === self.eventName.toLowerCase());
          }

          if (self.eventPlace) {
            self.historyEventData = self.historyEventData.filter(a => a.location.toLowerCase() === self.eventPlace.toLowerCase());
          }

          self.dataEventCount = self.eventItems.length;
          if (self.historyEventData.length < self.pageEventSize) {
            self.eventItems = self.historyEventData;
          } 
          else {
            self.eventItems = self.historyEventData.slice(0, self.pageEventSize);
          }

          if (self.eventItems.length > 0) {
            self.showEventPager = true;
          }
          self.spinShowEvent = false;
        });
      },
      showSpinEvent() {
        this.spinShowEvent = true;
      },
      add_Event(data) {
        this.eventItems.push(data)
      },
      update_Event(id, data) {
        let itemIndex = this.eventItems.map(i => {
          return i.eventId;
        }).indexOf(id)
        this.eventItems.splice(itemIndex, 1, data);
      },
      view_Event(id, data) {
        let itemIndex = this.eventItems.map(i => {
          return i.eventId;
        }).indexOf(id)
        this.eventItems.splice(itemIndex, 1, data);
      },
      remove_Event(index) {
        let eventId = this.eventItems[index].eventId;
        deleteEvent(eventId).then(response => {
          this.eventItems.splice(index, 1);
          this.getAllEvents_Companies();
          this.$Message.success({
              content: "Event successfully deleted !",
              duration: 3
          });
        }).catch(error => {
          this.$Message.error({
              content: "An error occurred while deleting the event: " + error,
              duration: 3
          });
        })
      },
      changeEventPageSize(size) {
        this.pageEventSize = size;
        this.changeSelectedEventPage(1);
      },
      changeSelectedEventPage(index) {
        let _start = (index - 1) * this.pageEventSize;
        let _end = index * this.pageEventSize;
        this.eventItems = this.historyEventData.slice(_start, _end);
      },

      changeEventYear: function (val) {
        this.selectedYear = val;
        this.getEventsData();
        this.open = false;
      },
      filterMethod(value, option) {
        let _value = value ? value.toUpperCase() : '';
        let _option = option ? option.toUpperCase() : '';
        return _option.indexOf(_value) !== -1;
      },
      getAllEvents_Companies() {
        //get all companies
        getCompanies(false)
          .then(response => {
            let companies = [];
            response.data.map(item => {
              let returnData = {
                companyId: item.companyId,
                companyName: item.companyName,
                address: item.address,
                barcode: item.barcode,
                city: item.city,
                country: item.country,
                deleted: item.deleted,
                email: item.email,
                logoUrl: item.logoUrl,
                phone: item.phone,
                eventIds: item.eventIds,
                languageId: item.languageId
              }
              companies.push(returnData);
            });
            localStorage.setItem('companies', JSON.stringify(companies));
            this.setCompanyListDetail(companies);

            //get all events
            getEvents(false)
              .then(response => {
                let eventIds = [];
                let events = [];
                response.data.map((evt) => {
                  let returnData = {
                    eventName: evt.eventName,
                    eventId: evt.eventId,
                    startDate: evt.startDate,
                    endDate: evt.endDate,
                    location: evt.location,
                    iconUrl: evt.iconUrl,
                    bannerUrl: evt.bannerUrl,
                    companyIds: evt.companyIds,
                    participantForm: evt.participantForm,
                    deleted: evt.deleted,
                    eventStatus: event.eventStatus
                  };
                  events.push(returnData);
                  eventIds.push(evt.eventId);
                });
                localStorage.setItem('events', JSON.stringify(events));
                localStorage.setItem('eventIds', JSON.stringify(eventIds));
                this.setEventList(events);

                this.$emit('collectEventsData', events, companies);
                bus.$emit('reloadSideMenu', events, companies);
              })
              .catch(error => {
                console.log('Get Events Failed! - LN 227 - ' + error);
              });
          })
          .catch(error => {
            console.log('Get Companies Failed! - LN 231 - ' + error);
          });
      }
    },
    created() {
      this.reRouteUser();
      this.getCompaniesData();
      this.getEventsData();
      this.$Spin.hide();
    },
    mounted() {
      this.reRouteUser();
      bus.$on('reloadAdminData', () => {
        this.spinShowCompany = true;
        this.spinShowEvent = true;
        this.getCompaniesData();
        this.getEventsData();
      });
      bus.$on('GetCompaniesEvents', () => {
        this.getAllEvents_Companies();
      });
      bus.$on('syncNewFormData', (event) => {
        const self = this;
        bus.$emit('getActiveLink', 'MyLeadForms');
        self.setFormOpened(true);
        localStorage.setItem('formOpened', true);
        setTimeout(function () {
          bus.$emit('syncLeadForm', event);
        }, 100);
      });
    }
  }
</script>
<style scoped>
  .ivu-card-custom {
    overflow: auto;
    height: auto;
  }

  .ivu-table table tbody tr td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table td {
    height: 80px;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

  .ivu-table-cell td, .ivu-table-cell th {
    border: 0;
    height: 20px;
    line-height: 1;
  }

  .greenBox {
    font-size: 20px;
    font-weight: 900;
    color: #fff;
    background-color: #35bc44;
    border-radius: 5px;
  }

  .grayBox {
    font-size: 20px;
    font-weight: 900;
    color: #fff;
    background-color: #6f6f70;
    border-radius: 5px;
  }

  .showAll {
    font-size: 20pt;
    background-color: green;
    position: relative;
  }

  .showActive {
    font-size: 25pt;
    background-color: transparent;
    position: relative;
  }

  .selectInput .ivu-select-input {
    background-color: #c6e5fd;
  }

  .btnAdds {
    background-color: #004f6e;
    color: #fff;
  }

  .btnAdds:hover {
    background-color: #ffffff;
    color: #004f6e;
  }

  .tableHeader {
    display: inline-block;
    width: 50%;
    font-size: 10pt;
    color: white;
    padding-top: 5px
  }

  a:link, a:visited {
    background-color: transparent;
    color: white;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/k_globalAdministration/globalAdmin.vue